import { categoryGroups } from '@/mocks/home';
import SectionHeading from '@/components/base/SectionHeading';

export default function CategorySummary() {
  return (
    <section id="summary" className="w-full scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <SectionHeading
          eyebrow="分类汇总"
          title="按分类浏览，节省查找时间"
          desc="六大类目覆盖内容聚合、资源合集、分类大全与索引导航，每一类都给出可继续下钻的子分类，浏览路径清楚。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {categoryGroups.map((group) => (
            <div
              key={group.name}
              className="flex flex-col rounded-xl border border-background-200 bg-background-100/50 p-5 transition-colors hover:border-secondary-300"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-950">
                    {group.name}
                  </h4>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">
                    {group.desc}
                  </p>
                </div>
                <span className="shrink-0 rounded-full bg-accent-100 px-2.5 py-1 font-label text-[11px] text-accent-900">
                  {group.count}
                </span>
              </div>

              <ul className="mt-5 flex flex-1 flex-col gap-2.5">
                {group.items.map((sub) => (
                  <li key={sub} className="flex items-center gap-2">
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-secondary-400" />
                    <a
                      href="#categories"
                      className="cursor-pointer text-[13px] text-foreground-700 transition-colors hover:text-primary-700"
                    >
                      {sub}
                    </a>
                  </li>
                ))}
              </ul>

              <a
                href="#categories"
                className="mt-5 flex items-center gap-1.5 border-t border-background-200 pt-4 font-label text-[13px] text-foreground-800 transition-colors hover:text-primary-700"
              >
                查看该分类
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}